module.exports = __webpack_public_path__ + "static/media/BAJFINANCE_F1.cff22ec7.txt";